import React from "react";

export type CustomCssContextType = {
  landingBackgroundColor: string;
  landingPrimaryFontColor: string;
  landingBackgroundImage: string;
  formBackgroundColor: string;
  formPrimaryFontColor: string;
  formButtonColor: string;
  formButtonFontColor: string;
  formLinkColor: string;
  formH1FontColor: string;
  formHelperFontColor: string;
  formFont: string;

  cssVariables: object | null;
  customStyles: string | null;
};

export const CustomCssContextEmpty: CustomCssContextType = {
  landingBackgroundColor: "#fff",
  landingPrimaryFontColor: "#000",
  landingBackgroundImage: "none",
  formBackgroundColor: "#fff",
  formPrimaryFontColor: "#000",
  formButtonColor: "#000",
  formButtonFontColor: "#fff",
  formLinkColor: "#005ddd",
  formH1FontColor: "#050608",
  formHelperFontColor: "#0009",
  formFont: "var(--sheerid-font-family-sans)",

  cssVariables: null,
  customStyles: null,
};

export const CustomCssContext = React.createContext(CustomCssContextEmpty);
